module.exports = __webpack_public_path__ + "static/img/envelope03thai.5017caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope03thai.png
// module id = ykMR
// module chunks = 1